import React, { useState } from "react";

import { LoadingIcon as Loading } from "@packages/ds";
import { useIntl, FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";

import NewProjectButton from "Components/NewProjectButton";
import { APP_NAME } from "Constants/documentationUrls";
import { organizationByDescriptionIdSelector } from "Reducers/organization";
import { useLoadOrder } from "Reducers/organization/order/hooks/useLoadOrder";
import { useLoadOrders } from "Reducers/organization/order/hooks/useLoadOrders";
import OrderItemList from "src/organization/pages/billing/components/OrderItemList";
import { useAppSelector } from "Store/hooks";
import Illustration from "Vendor_resources/images/empty-projects.svg";
import IllustrationDark from "Vendor_resources/images/empty-projects_dark.svg";

import * as S from "./styles";

const BillingListField = ({ organizationId, titleFilter }) => {
  const intl = useIntl();
  const theme = useTheme();

  const [expandedItem, setExpandedItem] = useState("");
  const [orderId, setOrderId] = useState("");

  const expand = id => {
    expandedItem === id ? setExpandedItem("") : setExpandedItem(id);
  };

  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: organizationId
    })
  );

  const loadOrder = orderId => {
    setOrderId(orderId);
  };

  const {
    recurring,
    previous,
    loading: loadingOrders
  } = useLoadOrders(organizationId);

  const { rawData } = useLoadOrder({ organizationId, orderId });

  const orderDetails = rawData;

  const recurringOrders = recurring ? Object.values(recurring) : null;
  const previousOrders = previous ? Object.values(previous) : null;

  return (
    <S.Layout>
      {loadingOrders && <Loading />}
      {!loadingOrders &&
      ((recurringOrders && recurringOrders?.length > 0) ||
        (previousOrders && previousOrders?.length > 0)) ? (
        <>
          <OrderItemList
            orders={recurringOrders}
            title={intl.formatMessage(
              {
                id: "billing.invoices.list.recurring.title",
                defaultMessage: "Recurring Platform.sh subscription"
              },
              { appName: APP_NAME || "Platform.sh" }
            )}
            loadOrder={loadOrder}
            isLoading={loadingOrders}
            expand={expand}
            orderDetails={orderDetails}
            expandedItem={expandedItem}
            titleFilter={titleFilter}
            organizationId={organizationId}
          />
          <OrderItemList
            orders={previousOrders}
            title={intl.formatMessage({
              id: "billing.invoices.list.previous.title",
              defaultMessage: "Previous"
            })}
            loadOrder={loadOrder}
            isLoading={loadingOrders}
            expand={expand}
            orderDetails={orderDetails}
            expandedItem={expandedItem}
            titleFilter={titleFilter}
            organizationId={organizationId}
          />
        </>
      ) : !loadingOrders && organization ? (
        <S.EmptyWrapper>
          <S.EmptyImage>
            <img
              src={theme.name === "dark" ? IllustrationDark : Illustration}
              alt={intl.formatMessage({
                id: "billing.invoices.list.empty.title"
              })}
            />
          </S.EmptyImage>
          <S.Title tag="h2">
            <FormattedMessage
              id="billing.invoices.list.empty.title"
              defaultMessage="You have no invoices"
            />
          </S.Title>
          <p>
            <FormattedMessage
              id="billing.invoices.list.empty.description"
              defaultMessage="Find monthly invoices for any projects that you own here after you create a project."
            />
          </p>
          <NewProjectButton
            organizationId={organizationId}
            isLink
            linkVariant="link"
          />
        </S.EmptyWrapper>
      ) : null}
    </S.Layout>
  );
};

export default BillingListField;
